import React from 'react';
import { NavLink } from 'react-router-dom';

const ClubNav = () => {
    return (
        <div className="club-nav-container">
            <div className="club-nav">
                <NavLink
                    to={``}
                    end
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    WER SIND WIR
                </NavLink>
                <NavLink
                    to={`/ueber/struktur`}
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    STRUKTUR
                </NavLink>
                <NavLink
                    to={`/ueber/downloads`}
                    className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
                >
                    DOWNLOADS
                </NavLink>
            </div>
        </div>
    );
}

export default ClubNav;